import type { EventType } from "app/types/eventType";
import React from "react";
import { FormattedMessage } from "react-intl";
import AsianMarketPeriods from "../../../AsianMarketPeriods/AsianMarketPeriods";

type Props = {
  showUnsummarizedMarketsModal: boolean;
  unsummarizedMarketsModalEventId: number;
  highestNumberOfMarkets: number;
  hasPrices: any;
  addBetSlip: (...args: Array<any>) => any;
  event: EventType;
  hasAdditionalMarkets: boolean;
  translatedMarketName: string;
};

const AsianEventMarketsContainer: React.FC<Props> = ({
  showUnsummarizedMarketsModal,
  unsummarizedMarketsModalEventId,
  event,
  hasPrices,
  highestNumberOfMarkets,
  addBetSlip,
  hasAdditionalMarkets,
  translatedMarketName,
}) => {
  return (
    <div className="asian-event__markets-container">
      <div className="asian-event__markets">
        {/* ARCH-85 initial placeholder temp logic */}
        {showUnsummarizedMarketsModal === true &&
        unsummarizedMarketsModalEventId === event.id ? (
          <div className="hide-market-summary-view">&nbsp;</div>
        ) : hasPrices ? (
          <AsianMarketPeriods
            marketPeriods={event.marketPeriods}
            markets={event.markets}
            event={event}
            key={event.id}
            highestNumberOfMarkets={highestNumberOfMarkets}
            addBetSlip={addBetSlip}
          />
        ) : hasAdditionalMarkets ? (
          <div className="asian-event__no-odds">
            <span className="asian-event__no-odds__market-type"></span>
          </div>
        ) : (
          <div className="asian-event__no-odds">
            <FormattedMessage
              tagName="span"
              id={"events-no-odds"}
              className="no-odds-available"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AsianEventMarketsContainer;
